import React, { useState, useContext } from "react";
import "./home-style.css";
import LanguageContext from "../../context/LanguageContext";

const jsonDataEn = require("./data/home-data-en.json");
const jsonDataFr = require("./data/home-data-fr.json");

const Navbar = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.navbar : jsonDataFr.data.navbar;
  return (
    <>
      <header className="header-home">
        <div className="home-logo">
          <a href="/" className="nav__brand" aria-label="FlxDeck Home">
            <img src="/assets/home/invered_Logo.webp" alt="FlxDeck" />
          </a>
        </div>
        <div className="partner-btn">
          <a href="/#contact" className="nav__cta">
            {data.btn}
          </a>

          <span className={language === "en" ? "d-none" : "active home-language-button"} onClick={() => setLanguage("en")} data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            EN
          </span>
          <span className={language === "fr" ? "d-none" : "active home-language-button"} onClick={() => setLanguage("fr")} data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            FR
          </span>
        </div>
      </header>
    </>
  );
};

export default Navbar;
